import { render, staticRenderFns } from "./DownloadExample.vue?vue&type=template&id=20a8c7bb"
import script from "./DownloadExample.vue?vue&type=script&lang=ts"
export * from "./DownloadExample.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports